module.exports = __webpack_public_path__ + "img/card.2e5eac0c.svg";